import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppServiceService } from 'src/app/api/app-service.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.page.html',
  styleUrls: ['./otp-verification.page.scss'],
})
export class OTPVerificationPage implements OnInit {
  @Input() userData: any = null;
  @Input() operationType: string = '';
  @Input() previousCodeSentVia: string = '';

  public verificationCodeLength: number = 5;
  public verifyDigits: any = {
    "a": '',
    "b": '',
    "c": '',
    "d": '',
    "e": ''
  }
  public verifyDigitsFinal: string = '';
  public verificationCodeSending: boolean = false;
  public verificationInProgress: boolean = false;

  public verificationError: string = '';

  constructor(public modalController: ModalController, public appService: AppServiceService, public translate: TranslateService, public router: Router) {

  }

  ngOnInit() {
    console.log('email : ', this.userData.email);
  }

  dismiss() {
    this.modalController.dismiss();
  }

  /**
 * Verification input will trigger once user input a value
 * @param currentInput current entered input property name
 * @param nextInputId next focus element id
 */
  moveToNext(currentInput: string, nextInputId: string) {
    if (this.verifyDigits[currentInput] && this.verifyDigits[currentInput].trim()) {
      let nextEle = document.getElementById('v-' + nextInputId);
      if (nextEle) nextEle.focus();
    } else {
      // if input event triggered but there is no value after trim
      // then assign empty string and not move to next element
      this.verifyDigits[currentInput] = '';
    }

    this.genarateFinalVerificationCode();
  }

  /**
 * Genarate final verificaion code with input values
 */
  genarateFinalVerificationCode() {
    this.verifyDigitsFinal = '';
    this.verifyDigitsFinal += this.verifyDigits.a || '';
    this.verifyDigitsFinal += this.verifyDigits.b || '';
    this.verifyDigitsFinal += this.verifyDigits.c || '';
    this.verifyDigitsFinal += this.verifyDigits.d || '';
    this.verifyDigitsFinal += this.verifyDigits.e || '';
    // console.log('this.verifyDigitsFinal : ' , this.verifyDigitsFinal);
    if (this.verifyDigitsFinal.length !== this.verificationCodeLength) this.verifyDigitsFinal = '';
  }

  /**
   * Reset verification code inputs
   */
  resetVerificationCodeInputs() {
    this.verifyDigits.a = '';
    this.verifyDigits.b = '';
    this.verifyDigits.c = '';
    this.verifyDigits.d = '';
    this.verifyDigits.e = '';

    this.verifyDigitsFinal = '';
  }

  /**
 * Triggers when user past the code from email
 * @param event clipboard event to get copied text
 */
  onVerificationCodePast(event: ClipboardEvent) {
    // if (this.loading) return;

    let clipboardData = event.clipboardData;
    if (clipboardData) {
      let pastedText = clipboardData.getData('text');
      if (pastedText) {
        let code = pastedText.trim() || '';
        if (code.length === this.verificationCodeLength) {
          this.verifyDigits.a = code[0];
          this.verifyDigits.b = code[1];
          this.verifyDigits.c = code[2];
          this.verifyDigits.d = code[3];
          this.verifyDigits.e = code[4];

          this.genarateFinalVerificationCode();
        }
      }
    }
  }

  /**
   * verify mobile number 
   */
  verifyMobileNumber() {
    // reset any errors 
    this.verificationError = '';

    this.genarateFinalVerificationCode();
    if (this.verifyDigitsFinal) {
      // console.log(this.verifyDigitsFinal);
      this.verificationInProgress = true;
      
      this.appService.verifyOTPCode({ customer_id: this.userData.customer_id, operation_type: this.operationType, email: this.userData.email, mobile_number: this.userData.mobile_number, code: this.verifyDigitsFinal, password: this.operationType === 'verification_login' ? this.userData.password : '' }).then(async (response) => {
        // console.log(response);
        if (response.status) {
          // do if verification is success
          if (response.operation_type !== 'account_deletion')
            this.translate.get('key.verification_success').toPromise().then((res) => {
              this.appService.showToast(res, 'success', 'bottom', 3000);
            });

          response.otp_code = this.verifyDigitsFinal;
          this.modalController.dismiss({ isVerified: true, extra: response });
        } else {
          this.verificationError = response.msg;
        }
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.verificationInProgress = false;
      })
    } else {
      this.verificationError = 'key.please_enter_valid_verification_code';
      this.resetVerificationCodeInputs();
    }
  }

  /**
   * request new verification code
   */
  requestNewVerificationCode() {
    // check the count down is at 0, if not that means still countdown in progress
    if (!this.appService.requestVerificationResend) {
      this.verificationCodeSending = true;
      // clear verification code inputs if values entered
      this.resetVerificationCodeInputs();

      this.appService.requestVerificationCode({customer_id: this.userData.customer_id, operation_type: this.operationType, mobile_number: this.userData.mobile_number, email: this.userData.email }).then((response) => {
        if (response.status) {
          this.appService.startVerificationCodeIntervalCountdown();
        }
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.verificationCodeSending = false;
      })
    }
  }
}
